import { render, staticRenderFns } from "./DatasetAsImage.vue?vue&type=template&id=e65dc2de"
import script from "./DatasetAsImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetAsImage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports